module.exports = __webpack_public_path__ + "static/media/pro.725215a8.svg";